import { Entity } from '@backstage/catalog-model';

import { toKaaPTenant } from './kaapTenants';

/**
 * Whether the user manages the tenant: one of their security groups is among
 * the tenant's security object ids. `userGroupIds` must be lower-cased; the
 * tenant ids are compared in lower case.
 */
export const isTenantManagedBy = (
  userGroupIds: Set<string>,
  securityObjectIds?: string[],
): boolean => {
  return (
    securityObjectIds?.some(id => userGroupIds.has(id.toLowerCase())) ?? false
  );
};

/**
 * Same as `isTenantManagedBy`, for a catalog entity. A malformed tenant entity
 * is not managed by anyone, so one bad catalog entry can't break the list that
 * renders it.
 */
export const isEntityManagedBy = (
  userGroupIds: Set<string>,
  entity: Entity,
): boolean => {
  try {
    return isTenantManagedBy(
      userGroupIds,
      toKaaPTenant(entity).securityObjectIds,
    );
  } catch {
    return false;
  }
};
